import Marquee from "react-fast-marquee";

const words = ["PROTECT", "SUPPLY", "BUILD", "DELIVER", "SECURE", "SUSTAIN"];

export default function EditorialMarquee() {
  return (
    <section
      aria-hidden="true"
      className="relative py-16 md:py-24 overflow-hidden border-y border-navy-border"
      data-testid="editorial-marquee"
    >
      <Marquee gradient={false} speed={35} pauseOnHover={false}>
        {[...Array(3)].map((_, i) => (
          <span key={i} className="flex items-center">
            {words.map((w) => (
              <span
                key={w + i}
                className="marquee-outline text-[80px] md:text-[140px] lg:text-[180px] leading-none px-8"
              >
                {w}
                <span className="text-gold/60 mx-6">·</span>
              </span>
            ))}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
